import * as service from './Kudos.service'
export default {
  props: ["action"], //FG - FOOF - After Cert - First Release Security (7) - added the prop
  data() {
    var checkfuturedate = (rule, value, callback) => {

      if (value) {
        let inputdate = new Date(value)
        let todatdate = new Date()
        if (inputdate > todatdate) {
          return callback(new Error('Action Date should not be greater than today\'s date'))
        } else {
          callback()
        }

      } else {
        return callback(new Error('Please pick a date'))
      }
    }
    return {
      Kudoscolumnsq: ['ActionDate', 'Description', 'CommentedBy', 'ActionTypeName', 'Actions'],
      optionstable: {
        headings: {
          ActionDate: 'Date',
          Description: 'Description',
          CommentedBy: 'Kudos given by',
          ActionTypeName: 'Kudos for',

          Actions: ''
        },
        labelPosition: 'top',
        isediting: false,
        EditableColID: '',
        role: '',

        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        perPage: 10,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: ['ActionDate', 'Description', 'CommentedBy', 'ActionTypeName'],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },
      addKudos: {
        ActionDate: '',
        Id: '',
        commentedby: '',
        CommentedUserId: '',
        ActionTypeId: '',
        Description: ''

      },

      rules: {
        ActionDate: [{
          type: 'date',
          required: true,
          trigger: 'blur',
          validator: checkfuturedate,
        }],
        CommentedUserId: [{
            required: true,
            message: 'This field is required'
          },
          /*  {min: 1, max: 50, message: 'Length should be 1 to 50'}*/

        ],
        ActionTypeId: [{
          required: true,
          message: 'Please select one action type'
        }],

        Description: [{
          min: 1,
          max: 500,
          message: 'Length should be 1 to 500'
        }]

      },
      Kudos: [],
      KudosUsers: [],
      personnelID: '',
      radio2: 3,
      ActionTypes: [],
      kudoBackup: [],
      modalTitle: '',
      action: ""
    }
  },
  mounted() {
    let context = this
    this.personnelID = this.$route.params.id
    this.GetCommendableActionTypes()
    this.GetKudosGivenByUsers()

    this.$router.app.$on('add_kudos', (data) => {

      context.addKudos = {
        ActionDate: '',
        Id: '',
        commentedby: '',
        CommentedUserId: '',
        ActionTypeId: '',
        Description: ''

      }
      context.$refs['addKudos'].resetFields()
    })
    this.$router.app.$on('kudos_obj', (data) => {

      context.GetKudosById(data)

    })
    this.$router.app.$on('submit_kudos', (data) => {

      context.submitForm(data)

    })

    this.$router.app.$on('update_kudos', (data) => {

      context.EditKudos(data)

    })
    this.$router.app.$on('del_kudos', (data) => {

      context.del(data)

    })
  },
  beforeDestroy() {
    this.$root.$off('update_kudos')
    this.$root.$off('del_kudos')
    this.$root.$off('submit_kudos')
    this.$root.$off('kudos_obj')

  },

  methods: {

    GetKudosGivenByUsers() {
      let context = this
      loader.startLoader()
      service.GetKudosGivenByUsers().then(function (response) {

        if (response && response != null) {
          response.push({
            Id: 0,
            Name: 'Other'
          })

          context.KudosUsers = response

        } else {

          context.KudosUsers = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },

    GetKudosById(PersonnelId) {
      let context = this
      loader.startLoader()
      service.GetKudosById(PersonnelId).then(function (response) {

        context.addKudos = response
        context.addKudos.actiondate = new Date(response.ActionDate)
        loader.stopLoader()
        if (response) {


          /*     var ID = response.Id;
           let context = this;
           context.EditableColID = ID;


           context.addKudos.CommentedBy = response.CommentedBy;
           context.addKudos.actiontype = response.ActionTypeId;
           context.addKudos.description = response.Description;
           context.addKudos.CommentedUserId =   context.addKudos.CommentedBy ? 0 :  response.CommentedUserId;
           context.isediting = true;*/

          /*  for (var i = 0; i < response.length; i++) {

           context.Kudos[i].ActionDate=(context.Kudos[i].ActionDate)? context.$options.filters.fdate(context.Kudos[i].ActionDate):'';


           }*/

        } else {
          context.addKudos = []
        }

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    GetCommendableActionTypes() {
      let context = this
      loader.startLoader()
      service.GetCommendableActionTypes().then(function (response) {
        context.ActionTypes = response
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    del: function (data) {
      var ID = data
      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteKudos(ID).then(function (response) {

          //FG - FOOF - After Cert - First Release Security - added conditional statement below
          //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
          if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
            loader.stopLoader()
            return;
          }

          context.$router.app.$emit('action_done')

          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })
    },

    cancelpopup: function () {

      $('#Addkudosmodel').modal('hide')
    },

    EditKudos: function (formname) {

      // this.$refs[formname].validate((valid) => {
      //   if (valid) {
      let context = this
      loader.startLoader()

      let KudosModel = {
        Id: context.addKudos.Id,
        PersonnelId: context.$route.params.id,
        ActionDate: context.$options.filters.fdate(context.addKudos.ActionDate),
        ActionTypeId: context.addKudos.ActionTypeId,
        CommentedBy: context.addKudos.CommentedBy && context.addKudos.CommentedUserId === 0 ? context.addKudos.CommentedBy : '',
        CommentedUserId: context.addKudos.CommentedUserId !== 0 ? context.addKudos.CommentedUserId : '',
        Description: context.addKudos.Description

      }

      service.UpdateKudos(KudosModel).then(function (response) {
        //FG - FOOF - After Cert - First Release Security - added conditional statement below
        //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
          loader.stopLoader()
          return;
        }

        loader.stopLoader()

        context.$notify({
          title: 'Success',
          message: 'Successfully Updated Kudos',
          type: 'success'
        })

        context.$router.app.$emit('action_done')

      }, (error) => {

        loader.stopLoader()
        $('#AddKudosmodel').modal('hide')
        context.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },

    editcol: function (data, buttonType) {
      //FG - FOOF - After Cert - First Release Security (7) - this method does not seem to be used
      alert("KUDOS CONTROLLER BUTTON TYPE: " + buttonType)
      if(buttonType=="view") 
        this.action="V";
      else
        this.action="E";
      alert(this.action) 
      var ID = data.row.Id
      let context = this
      context.EditableColID = ID
      context.addKudos.actiondate = new Date(data.row.ActionDate)

      context.addKudos.CommentedBy = data.row.CommentedBy
      context.addKudos.actiontype = data.row.ActionTypeId
      context.addKudos.description = data.row.Description
      context.addKudos.CommentedUserId = context.addKudos.CommentedBy ? 0 : data.row.CommentedUserId
      context.isediting = true
      $('#Addkudosmodel').modal('show')
      this.modalTitle = 'Edit Kudos'

    },

    submitForm(formName) {


      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context = this
          loader.startLoader()

          let KudosModel = {

            PersonnelId: context.$route.params.id,
            ActionDate: context.$options.filters.fdate(context.addKudos.ActionDate),
            ActionTypeId: context.addKudos.ActionTypeId,

            Description: context.addKudos.Description,

            CommentedBy: context.addKudos.CommentedBy && context.addKudos.CommentedUserId === 0 ? context.addKudos.CommentedBy : '',
            CommentedUserId: context.addKudos.CommentedUserId !== 0 ? context.addKudos.CommentedUserId : '',
          }

          service.AddKudos(KudosModel).then(function (response) {
            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                    
              loader.stopLoader()
              return;
            }

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Successfully Created Kudos',
              type: 'success'
            })
            context.$router.app.$emit('action_done')

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'KUDOS - error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/Kudos/Kudos.controller.js